import { render, staticRenderFns } from "./addApp.vue?vue&type=template&id=5f157c10&scoped=true&"
import script from "./addApp.vue?vue&type=script&lang=js&"
export * from "./addApp.vue?vue&type=script&lang=js&"
import style0 from "./addApp.vue?vue&type=style&index=0&id=5f157c10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f157c10",
  null
  
)

export default component.exports